import barba from "@barba/core"
import base from "./barba-transitions/base"
import $ from "jquery"

export default {

    init() {

        barba.init({
            transitions: [base],
            // debug: true,
            // logLevel: "4",
            views: [{
                namespace: "contact",
                beforeEnter(data) {

                    setTimeout(() => {

                        $("#input_2_13").empty()

                        var formCaptcha = grecaptcha.render(document.getElementById("input_2_13"), {
                            "sitekey": "6LcZoawUAAAAAEzkEzccgImbzkN3RDOXUjkS4fK-",
                        });

                    }, 1600)

                }
            },{
                namespace: "single-formation",
                beforeEnter(data) {

                    setTimeout(() => {

                        $("#input_1_8").empty()

                        let $inscription_captcha = $(".bloc.inscription .ginput_recaptcha")
                        $inscription_captcha.empty()

                        grecaptcha.render(document.getElementById("input_1_8"), {
                            "sitekey": "6LcZoawUAAAAAEzkEzccgImbzkN3RDOXUjkS4fK-",
                        });

                        grecaptcha.render($inscription_captcha[0], {
                            "sitekey": "6LcZoawUAAAAAEzkEzccgImbzkN3RDOXUjkS4fK-",
                        });


                    }, 1600)

                }
            }]
        });

    }

};


